// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetRecordHistoryResponseContentQuarantinedInner
 */
export interface GetRecordHistoryResponseContentQuarantinedInner {
    /**
     * 
     * @type {string}
     * @memberof GetRecordHistoryResponseContentQuarantinedInner
     */
    reason: string;
    /**
     * 
     * @type {string}
     * @memberof GetRecordHistoryResponseContentQuarantinedInner
     */
    runId: string;
    /**
     * 
     * @type {string}
     * @memberof GetRecordHistoryResponseContentQuarantinedInner
     */
    timestamp?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GetRecordHistoryResponseContentQuarantinedInner
     */
    values: { [key: string]: string; };
}

/**
 * Check if a given object implements the GetRecordHistoryResponseContentQuarantinedInner interface.
 */
export function instanceOfGetRecordHistoryResponseContentQuarantinedInner(value: object): value is GetRecordHistoryResponseContentQuarantinedInner {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('runId' in value) || value['runId'] === undefined) return false;
    if (!('values' in value) || value['values'] === undefined) return false;
    return true;
}

export function GetRecordHistoryResponseContentQuarantinedInnerFromJSON(json: any): GetRecordHistoryResponseContentQuarantinedInner {
    return GetRecordHistoryResponseContentQuarantinedInnerFromJSONTyped(json, false);
}

export function GetRecordHistoryResponseContentQuarantinedInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRecordHistoryResponseContentQuarantinedInner {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
        'runId': json['runId'],
        'timestamp': json['timestamp'] == null ? undefined : json['timestamp'],
        'values': json['values'],
    };
}

export function GetRecordHistoryResponseContentQuarantinedInnerToJSON(json: any): GetRecordHistoryResponseContentQuarantinedInner {
    return GetRecordHistoryResponseContentQuarantinedInnerToJSONTyped(json, false);
}

export function GetRecordHistoryResponseContentQuarantinedInnerToJSONTyped(value?: GetRecordHistoryResponseContentQuarantinedInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
        'runId': value['runId'],
        'timestamp': value['timestamp'],
        'values': value['values'],
    };
}
